import { initialize } from '@progress-wad/litebox/src/litebox.js';

initialize({
  csshide: 'u-dn',
  center: true
});
